module.exports = __webpack_public_path__ + "static/latteexpress.1e1a315b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/latteexpress.jpg
// module id = 279
// module chunks = 35783957827783